import {
    IFloatFormItemProps,
    IFormItemElement,
    IIntFormItemProps,
    IStringFormItemProps,
    TextFormItem
} from "../model/FormModel";
import SimpleChoice from "../../../../ts/common/SimpleChoiceVO";
import React, {DetailedHTMLProps, InputHTMLAttributes, useState} from "react";
import ErrorWrapperFE from "../form-element/ErrorWrapperFE";
import AppButton from "../../../element/button/AppButton";

interface IProps extends IFormItemElement
{
    formItemProps:IStringFormItemProps|IFloatFormItemProps|IIntFormItemProps;
    choiceList?:SimpleChoice[];
    elementProps?: DetailedHTMLProps<InputHTMLAttributes<HTMLFieldSetElement>, HTMLFieldSetElement>
    hideLabel?:boolean
}

const DropdownFIE = (props: IProps) =>
{
    let {
        form,
        formItemProps,
        label,
        onItemChange,
        instructions,
        elementProps
    } = props;

    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const [, setSimpleState] = useState<any[]>([]);

    const formItem = form.requireFormItem(formItemProps, formItemProps.type ?? "string", true) as TextFormItem;

    label = label ?? formItem.name;

    const onChoiceSelected= (choice:SimpleChoice) => {
        setSimpleState([]);
        setShowDropdown(false)
        if(!formItem.setValue(choice.id)){
            return;
        }

        if(onItemChange){
            onItemChange(formItem.itemID)
        } else if(onItemChange !== null){
            form.onFormItemChange(formItem.itemID)
        }
    }

    const choiceList = props.choiceList ?? [];

    let selectedChoice:SimpleChoice|null = null;
    for(let choice of choiceList){
        if(choice.id === formItem.getCastValue()){
            selectedChoice = choice;
            break;
        }
    }
    if(!selectedChoice && choiceList.length){
        onChoiceSelected(choiceList[0])
    }


    return <div className={form.isFormItemHidden(formItem) ? "d-none" : ""}>
        <ErrorWrapperFE
            formItem={formItem}
        >

            <fieldset
                data-form-item-id={formItem.itemID}
                className="my-0"
                {...elementProps}
            >
                <div className="row">
                    <div className="col-12">
                        <label
                            className={"form-item-label" + (formItem.required ? " required" : "")+(props.hideLabel ? " visually-hidden" : "")}
                        >
                            {label}
                        </label>
                        {!!selectedChoice && <>
                            <div className="float-start me-2">
                                <div className="dropdown">
                                    <AppButton
                                        className={"btn btn-secondary dropdown-toggle " + (showDropdown ? "show" : "")}
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        id="filterDropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        onClick={() => {
                                            setShowDropdown(!showDropdown)
                                        }}
                                    >
                                        {selectedChoice.name}
                                    </AppButton>
                                    <div
                                        className={"dropdown-menu stay-on-page-dropdown-menu " + (showDropdown ? "show" : "")}
                                        aria-labelledby="filterDropdown">

                                        {choiceList.map((choice, index) =>

                                            <AppButton
                                                key={index}
                                                className="dropdown-item"
                                                nonButton={true}
                                                onClick={() => onChoiceSelected(choice)}
                                            >
                                                {choice.name}
                                            </AppButton>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>}

                    </div>
                    {!!instructions && (
                        <div className="col-12">
                            <span className="instructions">{instructions}</span>
                        </div>
                    )}
                </div>
            </fieldset>

        </ErrorWrapperFE>
    </div>;
}

export default DropdownFIE;